import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigService } from './config.service';
import { Module } from './system-domain.service';

@Injectable({
  providedIn: 'root'
})
export class SystemModuleService {
  private get apiUrl(): string {
    return `${this.configService.get('apiBaseUrl')}/SystemModule`;
  }

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) { }

  getAllModules(): Observable<Module[]> {
    return this.http.get<any>(`${this.apiUrl}`).pipe(
      map((response: any) => response.result || [])
    );
  }

  getModuleById(moduleId: number): Observable<Module> {
    return this.http.get<any>(`${this.apiUrl}/${moduleId}`).pipe(
      map((response: any) => response.result)
    );
  }

  createModule(module: Module): Observable<number> {
    return this.http.post<any>(`${this.apiUrl}`, module).pipe(
      map((response: any) => response.result)
    );
  }

  updateModule(moduleId: number, module: Module): Observable<boolean> {
    return this.http.put<any>(`${this.apiUrl}/${moduleId}`, module).pipe(
      map((response: any) => response.result)
    );
  }

  deleteModule(moduleId: number): Observable<boolean> {
    return this.http.delete<any>(`${this.apiUrl}/${moduleId}`).pipe(
      map((response: any) => response.result)
    );
  }
}
